import { types } from "../../../types/types";
import { fetchConToken } from "../../../helpers/fetch";
import { startSpinner, finishSpinner } from "../../ui/spinner";
import { handleErrorApi } from "../../../helpers/randoms";
import { startAlerta } from "../../ui/alertas";
import { filter, remplazarPorTildeASinTilde } from "../../../helpers/Buscador";


export const fetchPracticas =
  (textoBuscado = "", grupo) =>
  async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.abmCosegurosPracticasClean });

    try {
      const response = await fetchConToken(`Coseguros/obtenerPracticasDeCoseguro/${grupo}/${textoBuscado}`);
      let body = await response.json();
           
      if (response.ok) {
        dispatch({
          type: types.abmCosegurosPracticasTraerSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cargar las prácticas de coseguro.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };


export const fetchCoseguros =
  (textoBuscado = "") =>
  async (dispatch) => {
    dispatch({ type: types.abmCosegurosTraerStart });

    try {
      const response = await fetchConToken(`Coseguros`);
      let body = await response.json();
      if (textoBuscado !== "") {
        body = body.filter((n) =>
          filter(
            remplazarPorTildeASinTilde(n.descripcion),
            remplazarPorTildeASinTilde(textoBuscado)
          )
        );
      }
      if (response.ok) {
        dispatch({
          type: types.abmCosegurosTraerSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cargar los coseguros.",
        "Ha ocurrido un error. Intente nuevamente"
      );
      dispatch({ type: types.abmCosegurosTraerError });
    }
  };

export const guardarPracticas = (grupo, idsPracticas, handleClose) => async (dispatch) => {
  
  try {
    dispatch(startSpinner());
    
    let response = await fetchConToken(`Coseguros/actualizarPracticasDeCoseguro/${grupo}`, {idsPracticas}, "PUT");
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          "Practicas guardadas correctamente",
          "success",
          "Comando Exitoso"
        )
      );
      handleClose&& handleClose(false);
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al guardar las practicas del coseguro.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const guardarCoseguro = (idCoseguro, datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    
    let response;
    if (idCoseguro && !datos.nuevoPeriodo) {
      response = await fetchConToken(`Coseguros/${idCoseguro}`, datos, "PUT");
    } else {
      response = await fetchConToken(`Coseguros`, datos, "POST");
    }

    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          "Coseguro guardado correctamente",
          "success",
          "Comando Exitoso"
        )
      );
      dispatch(finishSpinner());
      dispatch(fetchCoseguros());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al guardar un nuevo coseguro.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const eliminarPractica = (id, Grupo) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`Coseguros/eliminarPracticaDeCoseguro/${id}`,"","PUT");
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          "Práctica eliminada correctamente",
          "success",
          "Comando Exitoso"
        )
      );
      dispatch(finishSpinner());
      dispatch(fetchPracticas(null, Grupo));
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Práctica el motivo de baja.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};
